import Modal from "./../../elements/Modal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as SuccessCheckIcon } from "../../assets/icons/successCheck.svg";

const SuccessModal = ({ handleClose, setSuccessModal,setSuccessMessage, successMessage,bodycls="" }) => {

  return (
    <Modal
      headerActions={
        <CloseIcon
          onClick={() => {
            setSuccessMessage(null);
            handleClose();
            setSuccessModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
    >
      <div className={bodycls} style={{"display": "flex" , "flex-direction": "column", "align-items": "center", "gap": "25px"}}>
      <span className="modalBodyHead">
        <SuccessCheckIcon />
      </span>
      <span className="modalBodyHead">{successMessage}</span>
      </div>
    </Modal>
  );
};

export default SuccessModal;
